import React, { useState } from 'react';
import './App.css';
import LandingPage from './components/LandingPage'; // Import the LandingPage component
import App from './App';

function Landing() {
  const [showLandingPage, setShowLandingPage] = useState(true); // State to control showing landing page
  const [selectedView, setSelectedView] = useState<'register' | 'search'>('register'); // New state to store the selected view

  const handleEnterApp = (view: 'register' | 'search') => {
    setSelectedView(view);
    setShowLandingPage(false);
  };

  return (
    <div className="App">
      {showLandingPage ? (
        <LandingPage onEnterApp={handleEnterApp} /> // Pass a handler to LandingPage
      ) : (
        <App initialActiveView={selectedView} /> // Pass the selected view to App
      )}
      <div className="app-version">v{process.env.REACT_APP_VERSION}</div>
    </div>
  );
}

export default Landing;
